// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Same sky palette as page + navbar */
.profile-page {
  --profile-accent: #1e5278;
  --profile-accent-hover: #164565;
  --profile-accent-soft: rgba(30, 82, 120, 0.12);
  --profile-danger: #b84747;
  --profile-danger-border: rgba(184, 71, 71, 0.45);
  --profile-danger-bg: rgba(184, 71, 71, 0.06);
  min-height: 100dvh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: linear-gradient(210deg, #c5dff7 0%, #eef2f7 52%, #f4f7fa 100%);
  color: #1c2d38;
}

.profile-wrapper {
  flex: 1 1 auto;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: clamp(1.25rem, 3vw, 2rem);
  padding: var(
      --navbar-offset,
      max(
        7.25rem,
        calc(
          max(10px, env(safe-area-inset-top, 0px)) + clamp(40px, 10vw, 56px) + 12px + 1px + 2.25rem
        )
      )
    )
    clamp(1rem, 3vw, 1.75rem) max(1.25rem, env(safe-area-inset-bottom, 0px));
}

.profile-sidebar-col {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 0 0 auto;
  width: min(100%, 320px);
  margin-top: 0;
  padding-top: 0;
}

.profile-main-col {
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin-top: 0;
  padding-top: 0;
  /* Space between segmented tabs and the card below */
  gap: 1.25rem;
}

/* Admin: segmented control (replaces mismatched MUI primary/secondary/success) */
.profile-segmented {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
  padding: 5px;
  gap: 4px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(21, 52, 72, 0.12);
  box-shadow: 0 2px 12px rgba(21, 52, 72, 0.06);
  box-sizing: border-box;
}

.profile-segment {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0.65rem 1rem;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #486581;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.profile-segment:hover {
  color: var(--profile-accent);
  background: rgba(255, 255, 255, 0.45);
}

.profile-segment.is-active {
  background: #fff;
  color: var(--profile-accent);
  box-shadow: 0 2px 8px rgba(21, 52, 72, 0.1);
}

.profile-segment:focus-visible {
  outline: 2px solid var(--profile-accent);
  outline-offset: 2px;
}

.profile-picture-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: clamp(1.35rem, 3vw, 1.65rem) !important;
  border-radius: 16px !important;
  text-align: center;
  box-shadow: 0 8px 28px rgba(21, 52, 72, 0.1) !important;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff !important;
  gap: 0.25rem;
}

.profile-info-card {
  flex: 1 1 auto;
  padding: clamp(1.35rem, 3vw, 2rem) !important;
  border-radius: 16px !important;
  display: flex;
  flex-direction: column;
  background-color: #fff !important;
  box-sizing: border-box;
  box-shadow: 0 8px 28px rgba(21, 52, 72, 0.1) !important;
  min-width: 0;
  gap: 0.25rem;
}

.profile-info-card .MuiTypography-h5 {
  color: #153448;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin-bottom: 0.75rem !important;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: clamp(0.65rem, 2vw, 1rem);
  margin-top: 0.35rem;
}

.profile-password-grid {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid rgba(21, 52, 72, 0.08);
}

@media (max-width: 720px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

.form-input,
.profile-field {
  width: 100%;
}

/* MUI fields: accent + calmer density */
.profile-page .profile-field .MuiInputLabel-root.Mui-focused {
  color: var(--profile-accent);
}

.profile-page .profile-field .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: var(--profile-accent);
}

.profile-page .profile-field .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: rgba(30, 82, 120, 0.35);
}

/* Footer: secondary action left, primary right */
.profile-form-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(21, 52, 72, 0.08);
}

.profile-form-footer--single {
  justify-content: flex-end;
}

.profile-page .profile-btn-primary.MuiButton-root {
  text-transform: none;
  font-weight: 600;
  padding: 0.55rem 1.35rem;
  border-radius: 10px;
  background-color: var(--profile-accent);
  color: #fff;
  box-shadow: none;
}

.profile-page .profile-btn-primary.MuiButton-root:hover {
  background-color: var(--profile-accent-hover);
  box-shadow: 0 6px 18px rgba(30, 82, 120, 0.28);
}

.profile-page .profile-btn-ghost.MuiButton-root {
  text-transform: none;
  font-weight: 600;
  color: var(--profile-accent);
  border-radius: 10px;
  padding: 0.5rem 0.75rem;
}

.profile-page .profile-btn-ghost.MuiButton-root:hover {
  background-color: var(--profile-accent-soft);
}

.profile-page .profile-btn-upload.MuiButton-root {
  text-transform: none;
  font-weight: 600;
  border-radius: 10px;
  padding: 0.5rem 1.15rem;
  margin-top: 0.35rem;
  color: var(--profile-accent);
  border-color: rgba(30, 82, 120, 0.35);
}

.profile-page .profile-btn-upload.MuiButton-root:hover {
  border-color: var(--profile-accent);
  background-color: var(--profile-accent-soft);
}

.profile-page .profile-btn-danger.MuiButton-root {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  color: var(--profile-danger);
  border-color: var(--profile-danger-border);
  background-color: var(--profile-danger-bg);
}

.profile-page .profile-btn-danger.MuiButton-root:hover {
  border-color: var(--profile-danger);
  background-color: rgba(184, 71, 71, 0.1);
}

.profile-table-wrap {
  width: 100%;
  overflow-x: auto;
  margin-top: 0.65rem;
  -webkit-overflow-scrolling: touch;
  border-radius: 10px;
  border: 1px solid rgba(21, 52, 72, 0.08);
}

.profile-table-wrap .MuiTable-root {
  min-width: 640px;
}

.profile-table-wrap .MuiTableHead-root .MuiTableCell-root {
  font-weight: 700;
  color: #153448;
  background: rgba(225, 236, 245, 0.65);
}

.profile-pic-wrapper {
  position: relative;
}

.profile-pic {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e2e8f0;
}

.edit-profile-pic-btn {
  position: absolute;
  bottom: 5px;
  right: 5px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border-radius: 50%;
  padding: 8px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease-in-out;
  opacity: 0;
}

@media (max-width: 900px) {
  .profile-wrapper {
    flex-direction: column;
    align-items: stretch;
  }

  .profile-sidebar-col {
    width: 100%;
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;
  }

  .profile-form-footer {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .profile-page .profile-btn-primary.MuiButton-root,
  .profile-page .profile-btn-ghost.MuiButton-root {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/profile.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,8CAA8C;EAC9C,yBAAyB;EACzB,gDAAgD;EAChD,4CAA4C;EAC5C,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B;;;;;;;;;4EAS0E;AAC5E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,oDAAoD;EACpD,YAAY;AACd;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,mBAAmB;EACnB,qCAAqC;EACrC,wCAAwC;EACxC,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,uEAAuE;AACzE;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gDAAgD;EAChD,8BAA8B;EAC9B,kBAAkB;EAClB,uDAAuD;EACvD,WAAW;EACX,sBAAsB;EACtB,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,cAAc;EACd,6CAA6C;EAC7C,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,sBAAsB;EACtB,uDAAuD;EACvD,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE,WAAW;AACb;;AAEA,wCAAwC;AACxC;EACE,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* Same sky palette as page + navbar */\n.profile-page {\n  --profile-accent: #1e5278;\n  --profile-accent-hover: #164565;\n  --profile-accent-soft: rgba(30, 82, 120, 0.12);\n  --profile-danger: #b84747;\n  --profile-danger-border: rgba(184, 71, 71, 0.45);\n  --profile-danger-bg: rgba(184, 71, 71, 0.06);\n  min-height: 100dvh;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  background: linear-gradient(210deg, #c5dff7 0%, #eef2f7 52%, #f4f7fa 100%);\n  color: #1c2d38;\n}\n\n.profile-wrapper {\n  flex: 1 1 auto;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: clamp(1.25rem, 3vw, 2rem);\n  padding: var(\n      --navbar-offset,\n      max(\n        7.25rem,\n        calc(\n          max(10px, env(safe-area-inset-top, 0px)) + clamp(40px, 10vw, 56px) + 12px + 1px + 2.25rem\n        )\n      )\n    )\n    clamp(1rem, 3vw, 1.75rem) max(1.25rem, env(safe-area-inset-bottom, 0px));\n}\n\n.profile-sidebar-col {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex: 0 0 auto;\n  width: min(100%, 320px);\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.profile-main-col {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  margin-top: 0;\n  padding-top: 0;\n  /* Space between segmented tabs and the card below */\n  gap: 1.25rem;\n}\n\n/* Admin: segmented control (replaces mismatched MUI primary/secondary/success) */\n.profile-segmented {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  max-width: 100%;\n  padding: 5px;\n  gap: 4px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.55);\n  border: 1px solid rgba(21, 52, 72, 0.12);\n  box-shadow: 0 2px 12px rgba(21, 52, 72, 0.06);\n  box-sizing: border-box;\n}\n\n.profile-segment {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 0.65rem 1rem;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: #486581;\n  font-size: 0.875rem;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.profile-segment:hover {\n  color: var(--profile-accent);\n  background: rgba(255, 255, 255, 0.45);\n}\n\n.profile-segment.is-active {\n  background: #fff;\n  color: var(--profile-accent);\n  box-shadow: 0 2px 8px rgba(21, 52, 72, 0.1);\n}\n\n.profile-segment:focus-visible {\n  outline: 2px solid var(--profile-accent);\n  outline-offset: 2px;\n}\n\n.profile-picture-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: clamp(1.35rem, 3vw, 1.65rem) !important;\n  border-radius: 16px !important;\n  text-align: center;\n  box-shadow: 0 8px 28px rgba(21, 52, 72, 0.1) !important;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: #fff !important;\n  gap: 0.25rem;\n}\n\n.profile-info-card {\n  flex: 1 1 auto;\n  padding: clamp(1.35rem, 3vw, 2rem) !important;\n  border-radius: 16px !important;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff !important;\n  box-sizing: border-box;\n  box-shadow: 0 8px 28px rgba(21, 52, 72, 0.1) !important;\n  min-width: 0;\n  gap: 0.25rem;\n}\n\n.profile-info-card .MuiTypography-h5 {\n  color: #153448;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  margin-bottom: 0.75rem !important;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: clamp(0.65rem, 2vw, 1rem);\n  margin-top: 0.35rem;\n}\n\n.profile-password-grid {\n  margin-top: 0.5rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid rgba(21, 52, 72, 0.08);\n}\n\n@media (max-width: 720px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.form-input,\n.profile-field {\n  width: 100%;\n}\n\n/* MUI fields: accent + calmer density */\n.profile-page .profile-field .MuiInputLabel-root.Mui-focused {\n  color: var(--profile-accent);\n}\n\n.profile-page .profile-field .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: var(--profile-accent);\n}\n\n.profile-page .profile-field .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: rgba(30, 82, 120, 0.35);\n}\n\n/* Footer: secondary action left, primary right */\n.profile-form-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem 1rem;\n  margin-top: 1.25rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid rgba(21, 52, 72, 0.08);\n}\n\n.profile-form-footer--single {\n  justify-content: flex-end;\n}\n\n.profile-page .profile-btn-primary.MuiButton-root {\n  text-transform: none;\n  font-weight: 600;\n  padding: 0.55rem 1.35rem;\n  border-radius: 10px;\n  background-color: var(--profile-accent);\n  color: #fff;\n  box-shadow: none;\n}\n\n.profile-page .profile-btn-primary.MuiButton-root:hover {\n  background-color: var(--profile-accent-hover);\n  box-shadow: 0 6px 18px rgba(30, 82, 120, 0.28);\n}\n\n.profile-page .profile-btn-ghost.MuiButton-root {\n  text-transform: none;\n  font-weight: 600;\n  color: var(--profile-accent);\n  border-radius: 10px;\n  padding: 0.5rem 0.75rem;\n}\n\n.profile-page .profile-btn-ghost.MuiButton-root:hover {\n  background-color: var(--profile-accent-soft);\n}\n\n.profile-page .profile-btn-upload.MuiButton-root {\n  text-transform: none;\n  font-weight: 600;\n  border-radius: 10px;\n  padding: 0.5rem 1.15rem;\n  margin-top: 0.35rem;\n  color: var(--profile-accent);\n  border-color: rgba(30, 82, 120, 0.35);\n}\n\n.profile-page .profile-btn-upload.MuiButton-root:hover {\n  border-color: var(--profile-accent);\n  background-color: var(--profile-accent-soft);\n}\n\n.profile-page .profile-btn-danger.MuiButton-root {\n  text-transform: none;\n  font-weight: 600;\n  border-radius: 8px;\n  color: var(--profile-danger);\n  border-color: var(--profile-danger-border);\n  background-color: var(--profile-danger-bg);\n}\n\n.profile-page .profile-btn-danger.MuiButton-root:hover {\n  border-color: var(--profile-danger);\n  background-color: rgba(184, 71, 71, 0.1);\n}\n\n.profile-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n  margin-top: 0.65rem;\n  -webkit-overflow-scrolling: touch;\n  border-radius: 10px;\n  border: 1px solid rgba(21, 52, 72, 0.08);\n}\n\n.profile-table-wrap .MuiTable-root {\n  min-width: 640px;\n}\n\n.profile-table-wrap .MuiTableHead-root .MuiTableCell-root {\n  font-weight: 700;\n  color: #153448;\n  background: rgba(225, 236, 245, 0.65);\n}\n\n.profile-pic-wrapper {\n  position: relative;\n}\n\n.profile-pic {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid #e2e8f0;\n}\n\n.edit-profile-pic-btn {\n  position: absolute;\n  bottom: 5px;\n  right: 5px;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  border-radius: 50%;\n  padding: 8px;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.3s ease-in-out;\n  opacity: 0;\n}\n\n@media (max-width: 900px) {\n  .profile-wrapper {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .profile-sidebar-col {\n    width: 100%;\n    max-width: 420px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .profile-form-footer {\n    flex-direction: column-reverse;\n    align-items: stretch;\n  }\n\n  .profile-page .profile-btn-primary.MuiButton-root,\n  .profile-page .profile-btn-ghost.MuiButton-root {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
